import React from "react";
import { graphql, StaticQuery } from "gatsby";
import Prose from "../utility/prose";
import axios from 'axios'

class OperatorContactForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            name: '',
            email: '',
            message: '',
            agreement: false,
            captcha: undefined,
            recaptchaInstance: undefined,
            formError: [],
            formSuccess: '',
        }
    }

    componentDidMount() {
        if(this.state.recaptchaInstance) {
            this.state.recaptchaInstance.reset();
        }
    }

    submit = (event) => {
        event.preventDefault()
        this.setState( { formSuccess: '', formError: [] }, this.handleFormEntry )

    }

    handleFormEntry = () => {

        // console.log(this.props.title)

        if( this.state.name     === '' ||
            this.state.email    === '' ||
            this.state.address  === '' ||
            this.state.message  === ''
          ) {
            this.setState({ formError: this.state.formError.concat(["Form not filled out completely."]) })
        } else {
            let formData = new FormData() 
            formData.set('name', this.state.name)
            formData.set('email', this.state.email)
            formData.set('message', this.state.message)
            formData.set('address', this.state.address)
            // formData.set('website', this.props.title)
            formData.set('website', 'Newport MUD - Operations')
            formData.set('response', this.state.captcha)

            axios.post('https://backend.touchstonedistrictservices.com/mailer', formData, 
                {
                    headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'application/json',
                    }
                }).then( function(response) {
                    // console.log('Response');
                    // console.log(response.data);
                    if(response.data.status === "success") {
                        this.clearForm()
                        this.setState({ formSuccess: "Your message has been sent." })
                    } else {
                        this.setState({ formError: this.state.formError.concat(["Something went wrong, check your entry and try again."]) })
                    }

            }.bind(this) ).catch( function(error) {
                console.log(error.response)
            })

            if(this.state.recaptchaInstance) {
                this.state.recaptchaInstance.reset();
            }

        }

    }

    clearForm = () => {
        this.setState({ name: '', email: '', address: '', message: ''})
    }

    changeName = (event) => {
        this.setState({ name: event.target.value })
    }
    changeAddress = (event) => {
        this.setState({ address: event.target.value })
    }
    changeAgreement = (event) => {
        this.setState({ agreement: event.target.checked })
    }
    changeEmail = (event) => {
        this.setState({ email: event.target.value })
    }
    changeMessage = (event) => {
        this.setState({ message: event.target.value })
    }
    captchaVerify = (response) => {
        this.setState({ captcha: response })
    }
    onLoadRecaptcha = () => {
        if(this.state.recaptchaInstance) {
            this.state.recaptchaInstance.reset();
        }
    }


    render() {
        return (
            <Prose>
            <div className="w-full md:w-5/6 lg:w-2/3 mx-auto">
                <h2>Send us a message</h2>

                <form name="contact" onSubmit={this.submit}>
                    { this.state.formError.length !== 0 ? (<ul className="list-none text-red-500 dark:text-red-400 border-red-400 dark:border-red-400 border-2 rounded-3xl">{this.state.formError.map((error) => (
                        <li className="" key={error} >{error}</li>
                    )) }</ul>): < ></ > }
                    { this.state.formSuccess === '' ? ( < ></ > ) : (<ul className="list-none text-emerald-500 border-emerald-500 dark:text-emerald-400 dark:border-emerald-400 border-2 rounded-3xl"><li>{this.state.formSuccess}</li></ul>)}

                    <div className="mb-2">
                        <label htmlFor="name" className="text-sm uppercase pl-6">Name</label>
                        <input className="block w-full rounded-full bg-zinc-200 dark:bg-zinc-800 border-0 pl-6" type="text" name="name" placeholder="Enter your name" onChange={this.changeName} value={this.state.name} />
                    </div>
                    <div className="mb-2">
                        <label htmlFor="email" className="text-sm uppercase pl-6">Email</label>
                        <div className="control">
                            <input className="block w-full rounded-full bg-zinc-200 dark:bg-zinc-800 border-0 pl-6" type="email" name="email" placeholder="Enter your email" onChange={this.changeEmail} value={this.state.email} />
                        </div>
                    </div>
                    <div className="mb-2">
                        <label htmlFor="address" className="text-sm uppercase pl-6">Address</label>
                        <div className="control">
                            <input className="block w-full rounded-full bg-zinc-200 dark:bg-zinc-800 border-0 pl-6" type="text" name="address" placeholder="Enter your street address" onChange={this.changeAddress} value={this.state.address} />
                        </div>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="message" className="text-sm uppercase pl-6">Message</label>
                        <div className="control">
                            <textarea className="block w-full h-36 rounded-3xl bg-zinc-200 dark:bg-zinc-800 border-0 pl-6" name="message" placeholder="Enter your message" onChange={this.changeMessage} value={this.state.message}></textarea>
                        </div>
                    </div>
                    <div className="">
                        <div className="control">
                            <input className="inline-block text-base uppercase bg-emerald-300 hover:bg-emerald-400 dark:bg-emerald-700 hover:dark:bg-emerald-800 mr-1 mb-2 px-4 py-2 rounded-full leading-none" type="submit" name="submit" value="Submit" />
                        </div>
                    </div>
                </form>
            </div>
            </Prose>
        )
    }
}

export default () => (
    <StaticQuery query={graphql`
        query {
            site {
                siteMetadata {
                    title
                }
            }
        }
    `}
    render={(data) => (
        <OperatorContactForm title={data.site.siteMetadata.title} />
    )} 
    />
)